/**
 * Request access page — form for prospective users.
 *
 * Flask logs the submission and redirects back with a flash.
 */
import { useState } from 'react'
import { API_BASE } from '../../lib/api'
import './auth.css'

export default function RequestAccess() {
  const successParam = new URLSearchParams(window.location.search).get('success')
  const [submitted] = useState(!!successParam)

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">Priori</div>
        <h1 className="auth-title">Request access</h1>
        <p className="auth-sub">
          Tell us about yourself and your club. We'll be in touch.
        </p>

        {submitted && (
          <div className="auth-flash auth-flash--success">
            Your request has been submitted. We'll be in touch soon!
          </div>
        )}

        <form action={`${API_BASE}/auth/request-access`} method="POST">
          <label className="auth-field">
            <span className="auth-label">Name</span>
            <input className="auth-input" name="name" type="text"
                   placeholder="Jane Coach" required />
          </label>
          <label className="auth-field">
            <span className="auth-label">Email</span>
            <input className="auth-input" name="email" type="email"
                   placeholder="you@club.com" required autoComplete="email" />
          </label>
          <label className="auth-field">
            <span className="auth-label">Organization</span>
            <input className="auth-input" name="organization" type="text"
                   placeholder="Club or company name" />
          </label>
          <label className="auth-field">
            <span className="auth-label">Message (optional)</span>
            <textarea className="auth-textarea" name="message"
                      placeholder="How you'd like to use Priori..." />
          </label>
          <button className="auth-btn auth-btn--primary" type="submit">
            Request access
          </button>
        </form>

        <div className="auth-links">
          <a href="/login">Back to sign in</a>
        </div>
      </div>
    </div>
  )
}
